module.exports = __webpack_public_path__ + "static/media/ts14sj.11c47d52.png";